import {
    CREATE_USER_FORM_PRODUCTION_REPORT,
    FETCH_PRODUCTION_REPORTS_DATA_FAILURE,
    FETCH_PRODUCTION_REPORTS_DATA_REQUEST,
    FETCH_PRODUCTION_REPORTS_DATA_SUCCESS,
    FETCH_PROGRAM_REPORTS_DATA_FAILURE,
    FETCH_PROGRAM_REPORTS_DATA_REQUEST,
    FETCH_PROGRAM_REPORTS_DATA_SUCCESS,
    SET_SUMMARY_GRID_NAME_PRODUCTION_REPORT,
    CREATE_PRODUCTION_INWARD_REQUEST,
    CREATE_PRODUCTION_INWARD_FAILURE,
    CREATE_PRODUCTION_INWARD_SUCCESS,    
    FETCH_PRODUCTION_REPORT_REJECTQTY_REQUEST,
    FETCH_PRODUCTION_REPORT_REJECTQTY_SUCCESS,
    FETCH_PRODUCTION_REPORT_REJECTQTY_FAILURE,
    DELETE_REJECTION_QTY_REQUEST,
    DELETE_REJECTION_QTY_SUCCESS,
    DELETE_REJECTION_QTY_FAILURE,
    FETCH_PRODUCTION_REPORT_INWARD_REQUEST,
    FETCH_PRODUCTION_REPORT_INWARD_SUCCESS,
    FETCH_PRODUCTION_REPORT_INWARD_FAILURE,
} from "./productionReport.actionType";


export const PRODUCTION_REPORT = 'productionReport';

let initialState = {
    loading: false,
    productionReportData: [],
    productionWiseUserform: {
        fldFKUnitId: '',
        fldProgram: '',
        fldFKSubStyle: '',
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date()
    },
    renderGridBtn: 'summaryGrid',
    programReport: [],
    programReject: [],
    rejectQtyStyleWise : [],
    productionInwardData :[]
};

export let productionReportsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PRODUCTION_REPORTS_DATA_REQUEST:
        case CREATE_PRODUCTION_INWARD_FAILURE:
        case CREATE_PRODUCTION_INWARD_REQUEST:
        case DELETE_REJECTION_QTY_REQUEST:
        case DELETE_REJECTION_QTY_FAILURE:
        case FETCH_PRODUCTION_REPORT_INWARD_REQUEST:
        return {
                ...state,
                loading: true
            };
        case FETCH_PRODUCTION_REPORT_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                productionInwardData: updatePayload.YAI
            };
        case FETCH_PRODUCTION_REPORT_INWARD_FAILURE:
        case FETCH_PROGRAM_REPORTS_DATA_REQUEST:            

            return {
                ...state,
                loading: true
            };
        case FETCH_PRODUCTION_REPORTS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                productionReportData: updatePayload.YAI
            };
        case FETCH_PROGRAM_REPORTS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                programReport: updatePayload.PRD
            }       
        case FETCH_PRODUCTION_REPORTS_DATA_FAILURE:
        case FETCH_PROGRAM_REPORTS_DATA_FAILURE:

            return {
                ...state,
                loading: false
            };
        case FETCH_PRODUCTION_REPORT_REJECTQTY_REQUEST:            
            return {
                ...state,
                loading: true
            };
        case FETCH_PRODUCTION_REPORT_REJECTQTY_SUCCESS:
            return {
                ...state,
                loading: false,
                rejectQtyStyleWise: updatePayload
            }       
        case FETCH_PRODUCTION_REPORT_REJECTQTY_FAILURE:
        
        case SET_SUMMARY_GRID_NAME_PRODUCTION_REPORT:
            return {
                ...state,
                renderGridBtn: payload
            };

        case CREATE_USER_FORM_PRODUCTION_REPORT:
            return {
                ...state,
                loading: false,
                productionWiseUserform: {
                    ...state.productionWiseUserform,
                    [payload.key]: payload.value
                }
            }
        case CREATE_PRODUCTION_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {                   
                },
                programReject: updatePayload
            };
         case DELETE_REJECTION_QTY_SUCCESS:
                    return {
                        ...state,
                        loading: false,                      
                    };
        
        default:
            return state;
    }
};